import styled from "styled-components";
import FlagIcon from "../../../../../basic/flagIcon/FlagIcon";
import PhaseSixIcon from "../../../../../basic/phaseSixIcon/PhaseSixIcon";
import DesignConstants from "../../../../../constants/DesignConstants";

export const DirectionSelectorWrapper = styled.div`
    background: white;
    display: flex;
    cursor: pointer;
    align-items: center;
    border: ${DesignConstants.BORDERS.THIN} ${DesignConstants.COLORS.MID_GREY};
    background: ${DesignConstants.COLORS.BACKGROUND_LIGHT};
    justify-content: space-around;
    align-self: flex-start;
    border-radius: ${DesignConstants.SPACES.XL};
    width: fit-content;
    margin: 0 ${DesignConstants.SPACES.S};

    @media (max-width: ${DesignConstants.BREAKPOINTS.MD - 1}px) {
        flex-direction: column;
        align-items: stretch;
        align-self: stretch;
        width: 100%;
        margin: 0;
        background: ${DesignConstants.COLORS.WHITE};
        border: ${DesignConstants.BORDERS.THIN_GREY};
        border-radius: ${DesignConstants.BORDER_RADIUS.SMALL_CONTAINER};
        overflow: hidden;
    }
`;

export const StyledFlagIcon = styled(FlagIcon)`
    color: ${DesignConstants.COLORS.DARK_GREY};
    font-weight: ${DesignConstants.FONT_WEIGHTS.MEDIUM};

    svg {
        width: ${DesignConstants.SPACES.M};
        margin-right: ${DesignConstants.SPACES.XS};
        border-radius: ${DesignConstants.BORDER_RADIUS.SMALL_CONTAINER};
    }

    @media (max-width: ${DesignConstants.BREAKPOINTS.MD - 1}px) {
        span {
            font-size: ${DesignConstants.FONT_SIZES.M};
            font-weight: ${DesignConstants.FONT_WEIGHTS.MEDIUM};
        }
    }
`;

export const StyledPhase6Icon = styled(PhaseSixIcon)`
    font-size: ${DesignConstants.FONT_SIZES.XL};
    margin-top: 1px;
`;

export const RandomLabel = styled.span`
    display: inline-flex;
    align-items: center;
    gap: ${DesignConstants.SPACES.XS};

    @media (max-width: ${DesignConstants.BREAKPOINTS.MD - 1}px) {
        margin-left: ${DesignConstants.SPACES.XS};
        gap: ${DesignConstants.SPACES.S};
    }
`;

export const RandomIconSlot = styled.span`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 30px;

    @media (max-width: ${DesignConstants.BREAKPOINTS.MD - 1}px) {
        width: ${DesignConstants.SPACES.M};
    }
`;

export const SelectedCheckIcon = styled(PhaseSixIcon)`
    font-size: ${DesignConstants.FONT_SIZES.XL};
    color: ${DesignConstants.COLORS.DARK_GREY};
`;

export const DirectionItem = styled.div`
    width: auto;
    text-align: center;
    margin: 0 auto;
    padding: 0 ${DesignConstants.SPACES.M};
    display: flex;
    align-items: center;
    gap: ${DesignConstants.SPACES.XS};
    font-weight: ${DesignConstants.FONT_WEIGHTS.MEDIUM};
    font-size: ${DesignConstants.FONT_SIZES.L};
    height: ${DesignConstants.SIZES.ICON_XS};

    &.selected {
        border-radius: ${DesignConstants.SPACES.XL};
        background: white;
        border: ${DesignConstants.BORDERS.THIN} ${DesignConstants.COLORS.DARK_GREY};
    }

    @media (max-width: ${DesignConstants.BREAKPOINTS.MD - 1}px) {
        width: 100%;
        margin: 0;
        padding: ${DesignConstants.SPACES.XS} ${DesignConstants.SPACES.S};
        justify-content: space-between;
        height: auto;
        min-height: ${DesignConstants.SIZES.ICON_XS};
        font-size: ${DesignConstants.FONT_SIZES.M};
        border-bottom: ${DesignConstants.BORDERS.THIN_GREY};

        &:last-child {
            border-bottom: none;
        }

        &.selected {
            border: none;
            border-bottom: ${DesignConstants.BORDERS.THIN_GREY};
            border-radius: 0;
            background: ${DesignConstants.COLORS.WHITE};
        }

        &:last-child.selected {
            border-bottom: none;
        }
    }
`;
